import Abstract from "../../../abstract-view/abstract.js";

export default class Faq extends Abstract {
  constructor(wrapperElement) {
    super();

    this._wrapperElement = wrapperElement;
    this._listElement = null;
    this._categorySectionElement = null;
  }

  getCategorySectionElement() {
    if (!this._categorySectionElement) {
      this._categorySectionElement = this._wrapperElement.parentElement;
    }

    return this._categorySectionElement;
  }

  getElement() {
    this._element = this._wrapperElement.parentElement.querySelector(`.section_category-faq`);
    return this._element;
  }

  getListElement() {
    if (!this._listElement) {
      this._listElement = this.getElement().querySelector(`.faq-list`);
    }

    return this._listElement;
  }

  getContent() {
    return this._element.innerHTML.trim();
  }

  setContent(content) {
    this._element.innerHTML = content;
  }
}
